<template>
<div>
    <h1>Yksityisyysasetukset</h1>
    <p v-for="(paragraph, i) in store.globalSettings.mobilePrivacyInfo.split('\n')" class="about" :key="i">
        {{ paragraph }}
    </p>
    <i18n path="privacySettingsView.moreInfo" class="about" tag="p">
        <a place="email" :href="'mailto://' + sulEmail">{{ sulEmail }}</a><br>
        <a place="privacyPolicyUrl" href="" @click.prevent="openPrivacyPolicy()">{{ privacyPolicyUrl }}</a>
    </i18n>
</div>
</template>

<script lang="ts">
import { store } from 'store';
import xamatron from "xamatron";
import { defineComponent } from "vue";

export default defineComponent({
    mounted() {
        this.setTitle();
    },
    data() {
        return {
            store: store,
            sulEmail: "kunniakierros@sul.fi"
        };
    },
    computed: {
        privacyPolicyUrl() {
            return this.$getSiteUrl("public/privacypolicy");
        }
    },
    methods: {
        setTitle() {
            store.page.title = this.$t("privacySettingsView.title") as string;
        },
        openPrivacyPolicy() {
            xamatron.openURL(this.privacyPolicyUrl);
        }
    }
})

</script>